export enum EligibilityDataDispatchTypes {
  ELIGIBILITY_DATA_ERROR = "ELIGIBILITY_DATA_ERROR",
  ELIGIBILITY_DATA_INVOKE = "ELIGIBILITY_DATA_INVOKE",
  ELIGIBILITY_DATA_SUCCESS = "ELIGIBILITY_DATA_SUCCESS",
  ELIGIBILITY_DATA_RESET = "ELIGIBILITY_DATA_RESET",
}
export const fieldNames = [
  "informationReceived.subscriberFirstName",
  "informationReceived.subscriberLastName",
  "informationReceived.subscriberDateOfBirth",
  "informationReceived.subscriberGender",
  "informationReceived.relationshipTypeId",
];

export const RELATIONSHIP_TYPE_OTHER = 2;